export default __webpack_public_path__ + "static/media/backstageBackgroundjpg.35223ad8.jpeg";